<style>
@import '../../assets/css/transaction.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <el-input v-model="ajaxSearch.login" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_code')}}</template>
                        <el-input v-model="ajaxSearch.code" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('withdraw.table_coin_address')}}</template>
                        <el-input v-model="ajaxSearch.coin_address" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date')}}</template>
                        <b-form-input v-model="ajaxSearch.created_at" type="date"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_completed_at')}}</template>
                        <b-form-input v-model="ajaxSearch.completed_at" type="date"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_status')}}</template>
                        <b-form-select v-model="ajaxSearch.status_name">
                            <option value="">-</option>
                            <option v-for="(list,index) in ajaxToolList.withdrawStatusList" :key="index" :value='list.name'>{{list.name}}</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_coin')}}</template>
                        <b-form-select v-model="ajaxSearch.wallet_id">
                            <option value="">-</option>
                            <option v-for="(list,index) in ajaxToolList.coinList" :key="index" :value='list.code'>{{list.name}}</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_trader')}}</template>
                        <el-input v-model="ajaxSearch.trader_id" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <!-- <b-button variant="primary" class="mb-3 float-right" v-b-modal.exportWithdraw v-if="permissionList.includes(permission.export)"><font-awesome-icon icon="plus"/> {{$t('transaction_withdraw.table_export')}}</b-button>
                <b-button variant="primary" class="mb-3 mr-1 float-right" v-b-modal.importWithdraw v-if="permissionList.includes(permission.import)"><font-awesome-icon icon="plus"/> {{$t('transaction_withdraw.table_import')}}</b-button> -->
                <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        <template slot="header">
                            <p>{{title.label}}</p>
                            <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column type="expand">
                        <b-button variant="info" size="lg" @click="infoWithdraw()">{{$t('transaction_withdraw.table_info')}}</b-button>
                        <b-button variant="primary" size="lg" @click="getEditWithdraw()" class="ml-1" v-if="showEdit && permissionList.includes(permission.edit)">{{$t('transaction_withdraw.table_edit')}}</b-button>
                        <b-button variant="primary" size="lg" :href="ajaxUrl" target="_blank" class="ml-1" style="font-size: 15px;" v-if="showUrl">{{$t('admin.table_check_tx_id')}}</b-button>
                        <b-button variant="success" size="lg" @click="sendTelegram()" class="ml-1">{{$t('admin.table_send_telegeram')}}</b-button>
                        <b-button variant="danger" size="lg" @click="clearRemark()" v-if="permissionList.includes(permission.clearRemark)" class="ml-1">{{$t('admin.table_clear_remark')}}</b-button>                                       
                    </el-table-column>
                </el-table>
                <b-row class="mt-3">
                    <b-col sm="12" md="3" class="pr-0">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                    </b-col>
                    <b-col sm="12" md="9" class="pl-0">
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </b-col>
                </b-row>
            </b-card>
            <b-modal id="infoWithdraw" :title="$t('transaction_withdraw.table_check_withdraw')" hide-footer size="xl">
                <b-row class="form-label">
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_id')}}</template>
                            <label>{{ajaxInfo.id}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <label>{{ajaxInfo.created_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_completed_at')}}</template>
                            <label>{{ajaxInfo.completed_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <label>{{ajaxInfo.code}}</label>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <label>{{ajaxInfo.status_name}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_user')}}</template>
                            <label>{{ajaxInfo.login}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_trader')}}</template>
                            <label>{{ajaxInfo.trader_id}}</label>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <h5 style="text-decoration: underline;">{{$t('admin.table_coin_detail')}}</h5>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_coin')}}</template>
                            <label>{{ajaxInfo.wallet_name}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_total_coin_amount')}}</template>
                            <label>{{ajaxInfo.total_coin_amount}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_convert_rate')}}</template>
                            <label>{{ajaxInfo.convert_rate}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_convert_amount')}}</template>
                            <label>{{ajaxInfo.convert_amount}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_handling_fee')}}</template>
                            <label>{{ajaxInfo.handling_fee}} {{ajaxInfo.handling_coin}}</label>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_admin_fee')}}</template>
                            <label>{{ajaxInfo.admin_fee}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_total_pay')}}</template>
                            <label>{{ajaxInfo.total_pay}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_coin_address')}}</template>
                            <label style="word-break: break-all;">{{ajaxInfo.coin_address}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_tx_id')}}</template>
                            <label style="word-break: break-all;">{{ajaxInfo.tx_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_mitex_id')}}</template>
                            <label style="word-break: break-all;">{{ajaxInfo.mitex_id}}</label>                                                        
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
            <b-modal id="editWithdraw" :title="$t('transaction_withdraw.table_edit')" :ok-title="$t('button.submit')" :cancel-title="$t('button.close')" @ok="editWithdraw" size="lg">
                <b-row class="form-label">
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_id')}}</template>
                            <label>{{ajaxEdit.id}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <label>{{ajaxEdit.created_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <label>{{ajaxEdit.code}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_total_amount')}}</template>
                            <label>{{ajaxEdit.total_amount}}</label>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <label>{{ajaxEdit.status_name}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_user')}}</template>
                            <label>{{ajaxEdit.login}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_coin')}}</template>
                            <label>{{ajaxEdit.wallet_name}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_trader')}}</template>
                            <label>{{ajaxEdit.trader_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-select name="status" v-model="ajaxEdit.status">
                                <option v-for="(status,index) in statusList" :key="index" :value="status.id">{{status.name}}</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
            <b-modal id="exportWithdraw" :title="$t('transaction_withdraw.table_export')" @ok="exportWithdraw" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                <form id="exportWithdrawForm">
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_start')}}</template>
                        <el-date-picker v-model="ajaxExportStart" type="datetime" :placeholder="$t('admin.table_select_datetime')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </b-form-group>
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_end')}}</template>
                        <el-date-picker v-model="ajaxExportEnd" type="datetime" :placeholder="$t('admin.table_select_datetime')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </b-form-group>
                </form>
            </b-modal>
            <b-modal id="importWithdraw" :title="$t('transaction_withdraw.table_import')" @ok="importWithdraw" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                <form id="importWithdrawForm" @submit.prevent="importWithdraw">
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_import_file')}}</template>
                        <b-form-file name="uploadFile"></b-form-file>
                    </b-form-group>
                </form>
            </b-modal>
        </div>
    </div>
</template>

<script>
import {withdrawAjaxTable,withdrawInfo,getWithdrawEdit,withdrawEdit,withdrawExport,withdrawImport,withdrawSendTelegram,withdrawRemarkClear} from '@/system/model/transaction'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxToolList:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',completed_at:'',master_id:'',wallet_id:'',total_amount:'',coin_address:'',ip_address:'',remark:'',status_name:'',trader_id:'',login:''},
            ajaxRow:'',
            ajaxEdit:[],
            ajaxExportStart:'',
            ajaxExportEnd:'',
            statusList:[],
            showEdit: false,
            pageLimit:10,
            ajaxInfo:'',
            showUrl:false,
            ajaxUrl:'',
            ajaxCode:'',
            permission:{
                edit:'9EDE4D',
                export:'BBCBB9',
                import:'A48149',
                clearRemark:'DB1256'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'118'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'200'
            },{
                prop: "completed_at",
                label: this.$t('admin.table_completed_at'),
                width:'200'
            },{
                prop: "master_id",
                label: this.$t('admin.table_user'),
                width:'234'
            },{
                prop: "wallet_id",
                label: this.$t('admin.table_coin'),
                width:'150'
            },{
                prop: "total_amount",
                label: this.$t('admin.table_total_amount'),
                width:'234'
            },{
                prop: "coin_address",
                label: this.$t('withdraw.table_coin_address'),
                width:'234'
            },{
                prop: "ip_address",
                label: this.$t('admin.table_ip_address'),
                width:'150'
            },{
                prop: "status_name",
                label: this.$t('admin.table_status'),
                width:'150'
            },{
                prop: "trader_id",
                label: this.$t('admin.table_trader'),
                width:'234'
            },{
                prop: "remark",
                label: this.$t('admin.table_remark'),
                width:'234'
            }],        
        }
    },methods:{
        initialize(){
            var self = this;
            var result = withdrawAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.completed_at,this.ajaxSearch.master_id,this.ajaxSearch.wallet_id,this.ajaxSearch.total_amount,this.ajaxSearch.coin_address,this.ajaxSearch.ip_address,this.ajaxSearch.remark,this.ajaxSearch.status_name,this.ajaxSearch.trader_id,this.ajaxSearch.login);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.preloader(false);
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },infoWithdraw(){
            var self = this;
            var result = withdrawInfo(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                self.$bvModal.show('infoWithdraw');
                if(value.valid){
                    self.ajaxInfo = value.data;
                }
            });
        },getEditWithdraw(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getWithdrawEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('editWithdraw');
                    if(value.valid){
                        self.ajaxEdit = value.data;
                        self.statusList = value.status_list;
                    }
                });
            }
        },editWithdraw(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var formData = new FormData();
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('status', this.ajaxEdit.status); 
                formData.append('id', this.ajaxRow); 
                var result = withdrawEdit(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();  
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();  
                            }
                        });
                    }
                });
            }
        },exportWithdraw(){
            if(this.permissionList.includes(this.permission.export)){
                var self = this;
                var result = withdrawExport(this.ajaxExportStart,this.ajaxExportEnd);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        window.open(value.data, "_blank");    
                    }
                });
            }
        },importWithdraw(){
            if(this.permissionList.includes(this.permission.import)){
                var self = this;
                var form = document.getElementById('importWithdrawForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = withdrawImport(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();  
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();  
                            }
                        });
                    }
                });
            }
        },sendTelegram(){
            var self = this;
            var formData = new FormData();
            formData.append(this.csrfNameKey, this.csrfName); 
            formData.append(this.csrfValueKey, this.csrfValue); 
            formData.append('code', this.ajaxCode); 
            var result = withdrawSendTelegram(formData);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg),
                        onClose: () => {
                            self.initialize();  
                        }
                    });
                }else{
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }

                    self.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();  
                        }
                    });
                }
            });
        },clearRemark(){
            if(this.permissionList.includes(this.permission.clearRemark)){
                this.$swal.fire({
                text: this.$t('msg.comfirm_reset'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = withdrawRemarkClear(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id;
            this.ajaxCode = row.code;
            this.showEdit = false;
            if(row.status != 3 && row.status != 4 && row.status != 5){
                this.showEdit = true;
            }
            if(row.status == 3 || row.status == 4 || row.status == 5){
                this.showUrl = true;
                this.ajaxUrl = row.url
            }
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
